import StackChartBar from '@/molecules/chartElements/StackChartBar/StackChartBar';
import RelatedActivityEntities from '@/organisms/activities/RelatedActivityEntities/RelatedActivityEntities';
import { EntityMetric } from '@/lib/enums';
import Box from '@/components/Box';

const TagActivityList = ({
  color,
  entities,
  interactive,
  metricType,
  totalHours,
}) => {
  return (
    <Box>
      {entities.map((entity, index) => (
        <Box
          key={entity.uuid}
          sx={{
            mt: index === 0 ? 0 : 1.5,
          }}
        >
          <RelatedActivityEntities entity={entity} interactive={interactive}>
            <StackChartBar
              colors={color}
              interactive={interactive}
              title={entity.__description}
              numerator={entity.__aggregateHours}
              showNumerator={metricType !== EntityMetric.PERCENTAGE}
              numeratorLabel="Hours"
              denominator={totalHours}
            />
          </RelatedActivityEntities>
        </Box>
      ))}
    </Box>
  );
};

export default TagActivityList;
